import { mountLegislature } from './utils/mount-legislature.js';
import { STATE_URL } from './constants.js';
mountLegislature('california-us-house', STATE_URL, 'H').catch(console.error);
